import React from 'react';
import img1 from '../assets/Group 726.png';
import img2 from '../assets/Ellipse 66.png';
import { FaPhoneAlt } from "react-icons/fa";
import { LuGanttChartSquare } from "react-icons/lu";
import { IoCamera } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import CibilInsight from '../components/CibilInsight';
import  TotalAccounts from '../components/TotalAccounts';
import HomeLoan from '../components/HomeLoan';
import { useState } from 'react';
import CreditCards from '../components/CreditCards';
import Footer from '../components/Footer';
import { MdClose } from 'react-icons/md';

const UserProfile = () => {
    
    const [profilePic, setProfilePic] = useState(img2);
    const [cibilScore] = useState(444);
    //const [isFixed, setIsFixed] = useState(false);
    //const [isSticky, setIsSticky] = useState(false);
    const [name, setName] = useState('NAVEEN KUMAR ATAVA');
    const [phone, setPhone] = useState('9089789012');
    const [address, setAddress] = useState('00, Area name, vsp-515151');
    const [dob, setDob] = useState('00/00/0000');
    const [email, setEmail] = useState('google@email.com');
    const [aadhaarNo, setAadhaarNo] = useState('0000 0000');
    const [panNo, setPanNo] = useState('0000 0000 0000');

    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [editedName, setEditedName] = useState('');
    const [editedPhone, setEditedPhone] = useState('');
    const [editedAddress, setEditedAddress] = useState('');
    const [editedDob, setEditedDob] = useState('');
    const [editedEmail, setEditedEmail] = useState('');
    const [editedAadhaarNo, setEditedAadhaarNo] = useState('');
    const [editedPanNo, setEditedPanNo] = useState('');

    const toggleEditPopup = () => {
        setIsEditPopupOpen(!isEditPopupOpen);
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setName(editedName);
        setPhone(editedPhone);
        setAddress(editedAddress);
        setDob(editedDob);
        setEmail(editedEmail);
        setAadhaarNo(editedAadhaarNo);
        setPanNo(editedPanNo);
        setIsEditPopupOpen(false);
        toggleEditPopup();
    };

    //useEffect(() => {
        //const sideBox = document.getElementById("sideBox");
        //const footer = document.getElementById("footer");
        //const boxRect = sideBox.getBoundingClientRect();
        //const footerRect = footer.getBoundingClientRect();
        //const fixed = boxRect.top + window.scrollY - 80;
        //const limit = footerRect.top - boxRect.height - 110;
        
    //     const handleScroll = () => {
    //         const offset = window.scrollY;
    //         setIsFixed(offset > fixed);
    //         setIsSticky(offset > limit);
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        setProfilePic(file);
    };
    return (
    <>
    <div className='font-sans relative place-self-center px-2 lg:px-16 bg-slate-50 lineargradient1 w-full h-full visible overflow-hidden mt-20'>
        <div className={`flex flex-col justify-center items-center transition-all ease-in-out duration-200 bg-white z-40 rounded-lg border overflow-hidden border-primary shadow-xl max-h-[60%] w-[40%] fixed top-[50%] left-[50%] p-2 -translate-x-[50%] -translate-y-[50%] ${isEditPopupOpen ? 'scale-100 opacity-100':'scale-0 opacity-0'}`}>
            <MdClose className='absolute top-0 right-0 m-2 text-lg md:text-2xl cursor-pointer' onClick={toggleEditPopup} />
            <h2 className='text-primary font-semibold text-xl mt-5 mb-2'>ENTER YOUR DETAILS</h2>
            <form className='grid grid-cols-2 px-4 max-h-96 w-full' onSubmit={handleSubmit}>
                <div className="mb-2">
                    <label htmlFor="name" className="block text-black mb-1">User Name</label>
                    <input type="text" value={editedName} onChange={(e) => setEditedName(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="phone" className="block text-black mb-1">Phone</label>
                    <input type="text" id="phone" value={editedPhone} onChange={(e) => setEditedPhone(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="address" className="block text-black mb-1">Address</label>
                    <input type="text" id="address" value={editedAddress} onChange={(e) => setEditedAddress(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="dob" className="block text-black mb-1">Date of Birth</label>
                    <input type="text" id="dob" value={editedDob} onChange={(e) => setEditedDob(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="email" className="block text-black mb-1">Email</label>
                    <input type="text" id="email" value={editedEmail} onChange={(e) => setEditedEmail(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="aadhaarNo" className="block text-black mb-1">Aadhaar Number</label>
                    <input type="text" id="aadhaarNo" value={editedAadhaarNo} onChange={(e) => setEditedAadhaarNo(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-4">
                    <label htmlFor="panNo" className="block text-black mb-1">PAN Number</label>
                    <input type="text" id="panNo" value={editedPanNo} onChange={(e) => setEditedPanNo(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
            </form>
            <button onClick={handleSubmit} className="bg-primary text-white font-bold py-2 px-4 rounded focus:outline-none focus:bg-primary-dark hover:bg-primary-dark w-24">Save</button>
        </div>
        <div className={`flex flex-col items-center ${isEditPopupOpen? 'blur-sm':''}`}>
            <div className='visible bg-primary rounded-b-lg h-full lg:h-52 w-full flex flex-row justify-end items-end gap-5 p-3 overflow-visible'>
                <div id='sideBox' className={`h-fit bg-white rounded-lg w-[28%] lg:w-[260px] xl:w-[320px] 3xl:w-[400px] top-0 left-6 lg:left-20 xl:left-28 flex flex-col justify-center items-center text-center gap-2 py-1 lg:py-5 shadow-md absolute mt-10 lg:mt-20`}>
                    <div className='relative mt-2'>
                        <div className='aspect-w-1 aspect-h-1 rounded-full w-32 h-32 overflow-hidden'><img className='object-cover' src={typeof profilePic === 'string' ? profilePic : URL.createObjectURL(profilePic)} width={150} alt=''></img></div>
                        <label
                            htmlFor='imageInput'
                            className='cursor-pointer absolute right-0 bg-white bottom-5 rounded-full p-1'
                        >
                            <IoCamera className='text-xl' />
                        </label>
                        <input
                            id='imageInput'
                            className='hidden'
                            type='file'
                            accept='image/*'
                            onChange={handleImageChange}
                            required
                        />
                    </div>
                    <h2 className='text-md lg:text-lg xl:text-xl'>{name}</h2>
                    <div className='flex flex-col items-start gap-2'>
                        <p className='flex flex-row text-gray-500 items-center gap-3 max-xl:text-xs'><FaPhoneAlt/> {phone}</p>
                        <p className='flex flex-row text-gray-500 items-center gap-3 max-xl:text-xs'><LuGanttChartSquare /> {address}</p>
                    </div>
                    <div className='border-2 border-gray-300 rounded-lg flex flex-col items-center text-start gap-2 w-[85%] lg:w-[80%] h-full py-2 lg:py-3 mt-2'>
                        <h3 className='text-primary border-b border-gray-300 w-[90%] lg:w-[80%] leading-8 max-xl:text-sm'>Basic Details</h3>
                        <p className='text-gray-500 text-sm border-b border-gray-300 w-[90%] lg:w-[80%] leading-8 max-xl:text-xs'>D.O.B - {dob}</p>
                        <p className='text-gray-500 text-sm border-b border-gray-300 w-[90%] lg:w-[80%] leading-8 max-xl:text-xs'>Email - {email}</p>
                        <p className='text-gray-500 text-sm border-b border-gray-300 w-[90%] lg:w-[80%] leading-8 max-xl:text-xs'>Aadhaar no. - {aadhaarNo}</p>
                        <p className='text-gray-500 text-sm w-[90%] lg:w-[80%] leading-8 max-xl:text-xs'>PAN no. - {panNo}</p>
                    </div>
                    <div className='flex flex-row justify-center w-full xl:mt-4 max-xl:mb-1 mb-2'>
                        <button onClick={toggleEditPopup} className="flex flex-row justify-center gap-2 items-center bg-primary hover:text-gray-200 px-4 text-white rounded-3xl h-12 w-[80%]"><LuPencilLine />Edit Details</button>
                    </div>
                </div>
                <div className='flex justify-around items-end w-2/3'>
                    <h1 className='text-white text-2xl lg:text-3xl xl:text-4xl font-bold mb-2'> YOUR CIBIL INSIGHTS</h1>
                    <div className='overflow-hidden lg:w-1/3 w-[150px] relative 3xl:w-1/4'>
                        <img src={img1} alt='meter' className='w-full' />
                        <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 lg:-translate-y-[30%] bg-white text-sm lg:text-lg xl:text-2xl p-[1px] lg:p-1 text-center font-bold text-primary z-10'>{cibilScore}</div>
                    </div>

                </div>
            </div>
        </div>
        <div className={`flex flex-row items-end justify-end w-full mt-5 mb-52 ${isEditPopupOpen? 'blur-sm':''}`}>
            <div className='flex flex-col w-2/3 gap-4 mb-10 h-full'>
                <CibilInsight 
                    title="Total Accounts" 
                    accounts="11 Accounts"
                    accountDetails = "10 Active"
                    accountDetails1 = "01 Closed"
                    content = {<TotalAccounts/>}
                />
                <CibilInsight 
                    title="Home Loan" 
                    accounts="01 Account"
                    accountDetails = "01 Active"
                    accountDetails1 = "00 Closed"
                    content = {<HomeLoan />}
                />
                <CibilInsight 
                    title="Credit Cards" 
                    accounts=""
                    accountDetails = "2% Utilization"
                    content = {<CreditCards />}
                />
                <CibilInsight 
                    title="Personal Loan" 
                    accounts="06 Accounts"
                    accountDetails = "05 Active"
                    accountDetails1 = "01 Closed"
                    content = {<HomeLoan />}
                />
                <CibilInsight 
                    title="Vehicle Loan" 
                    accounts=""
                    accountDetails = "HDFC"
                    content = {<HomeLoan />}
                />
                <CibilInsight 
                    title="Credit Card Enquiries" 
                    accounts=""
                    accountDetails = "2 Enquiries"
                    accountDetails1 = "in last year"
                    content = {<HomeLoan />}
                />
                <CibilInsight 
                    title="Other Loans" 
                    accounts="06 Account"
                    accountDetails = "05 Active "
                    accountDetails1 = "01 Closed"
                    content = {<HomeLoan />}
                />

            </div>
        </div>
        <p className='sr-only'>KGST</p>
    </div>
    <div id='footer'>
        <Footer />
    </div>
    </>
    )
}

export default UserProfile;